import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const OFFER_VALIDATION_FAIL = 'PUBLISH_INFO :: OFFER_VALIDATION_FAIL';

export type TOfferValidationFailAction = IReduxAction<typeof OFFER_VALIDATION_FAIL>;

export const offerValidationFail = actionGenerator<typeof OFFER_VALIDATION_FAIL>(OFFER_VALIDATION_FAIL);
